import http   from '../services/http';
import tokens from './tokens';

import {
    LOGIN_ENDPOINT,
    LOGOUT_ENDPOINT,
    TOS_LINK_ENDPOINT
} from '../services/endpoints';

export default (() => {

    var clientsToNotify = [];

    var isWebTokenRefreshing = false;

    const login = (credentials) => {

        return http.post(LOGIN_ENDPOINT, credentials);
    };

    const logout = () => {

        return http.get(LOGOUT_ENDPOINT).then(clearSession);
    }

    const storeSessionToken = (token) => {

        window.localStorage.setItem('sessionToken', token);
    };

    const clearSession = () => {
        if ( window.localStorage.getItem('localStorage')) {
            window.localStorage.removeItem('sessionToken');
        }
    }

    const getSessionToken = () => {

        return window.localStorage.getItem('sessionToken');
    };

    const getSession = () => {

        var token = getSessionToken();

        if (token) {

            var base64Url = token.split('.')[1];

            var base64 = base64Url.replace('-', '+').replace('_', '/');

            return JSON.parse(window.atob(base64));

        } else {

            return null;
        }
    };

    const isSessionExpired = () => {

        return getSession() && getSession().exp < getCurrentUnixTimestamp();
    };

    const isRefreshRequired = () => {

        if (getSession()) {

            return isSessionExpired();

        } else {

            return false;
        }
    };

    const isTokenRefreshing = () => {

        return isWebTokenRefreshing;
    };

    const getCurrentUnixTimestamp = () => {

        return Math.floor(Date.now() / 1000);
    };

    const refreshToken = () => {

        isWebTokenRefreshing = true;

        return tokens.refreshToken()
            .then((response) => {

                storeSessionToken(response.data.data['token']);

                isWebTokenRefreshing = false;

                notifyClientsOnRefresh();
            });
    };

    const notifyClientsOnRefresh = () => {

        clientsToNotify.forEach((notify) => {

            notify();
        });

        clientsToNotify = [];
    };

    const onTokenRefresh = (callback) => {

        clientsToNotify.push(callback);
    };

    const getTermsOfServiceLink = () => {

        return http.get(TOS_LINK_ENDPOINT);
    };

    return {
        login,
        logout,
        getSession,
        refreshToken,
        isTokenRefreshing,
        isRefreshRequired,
        storeSessionToken,
        getSessionToken,
        isSessionExpired,
        onTokenRefresh,
        getTermsOfServiceLink
    };

})();


// WEBPACK FOOTER //
// ./services/authenticator.js